import { FileClient } from "../RestClient";

// 売掛金残高一覧表EXCEL出力リクエスト
export type B030060Request = {
  urikakeYm: string;
  shokaKbn: string;
} & Partial<{
  bumonCdFrom: string;
  bumonCdTo: string;
  shainCdFrom: string;
  shainCdTo: string;
  urikakeCdFrom: string;
  urikakeshitenCdFrom: string;
  urikakeCdTo: string;
  urikakeshitenCdTo: string;
}>;

// EXCEL出力処理
export const B030060GetExcel = (props: B030060Request) => {
  return FileClient.get("b030060/get/excel", {
    params: props,
  });
};
